import React from "react";
import moment from "moment";

import StatusBadge from "designV2/components/StatusBadge";
import { DetailField, CopyableField } from "../detailFields";
import "../superRide.css";

const TYPE_LABELS = { PERCENT: "Percentage", FIXED: "Fixed amount" };
const CONDITION_LABELS = { TIMELY: "Time limited", FIRST_TRIP: "First trip only" };
const FOR_LABELS = { RIDE: "Rides", DELIVERY: "Deliveries", ALL: "Rides and deliveries" };

const lifecycleOf = (promotion) => {
  const now = moment();
  if (promotion.to && moment(promotion.to).isBefore(now)) {
    return { tone: "neutral", label: "Expired" };
  }
  if (promotion.from && moment(promotion.from).isAfter(now)) {
    return { tone: "info", label: "Scheduled" };
  }
  return { tone: "success", label: "Live" };
};

/**
 * PromotionDetails - content-only, rendered inside a DialogShell.
 *
 * Shared by the ride and shop promotion screens, so it takes only the
 * promotion; the previous version accepted `type` and `theme` props that
 * nothing read.
 */
const PromotionDetails = ({ promotion }) => {
  const lifecycle = lifecycleOf(promotion);
  const used = (promotion.canNotUse && promotion.canNotUse.length) || 0;
  const eligible = (promotion.canUse && promotion.canUse.length) || 0;

  const value =
    promotion.type === "PERCENT"
      ? `${promotion.percent || 0}%`
      : `$${Number(promotion.percent || 0).toFixed(2)}`;

  return (
    <div className="superRideDetails superRideDetailsNarrow">
      <div className="superRideDetailsTop">
        <StatusBadge status={lifecycle.tone} label={lifecycle.label} />
        <span className="superRideTag">{TYPE_LABELS[promotion.type] || promotion.type}</span>
        <span className="superRideDetailsHeadline">{value}</span>
      </div>

      <div className="superRideGrid">
        <CopyableField label="Promotion code" value={promotion.promotionCode} />
        <CopyableField label="Promotion ID" value={promotion._id} />
        <DetailField
          label="Maximum discount"
          value={
            promotion.maximumPromotion
              ? `$${Number(promotion.maximumPromotion).toFixed(2)}`
              : null
          }
        />
        <DetailField label="Applies to" value={FOR_LABELS[promotion.for] || promotion.for} />
        <DetailField
          label="Condition"
          value={CONDITION_LABELS[promotion.condition] || promotion.condition}
        />
        <DetailField
          label="Use limit"
          value={promotion.useLimitCount ? `${promotion.useLimitCount} per customer` : "Unlimited"}
        />
        <DetailField
          label="Valid from"
          value={promotion.from ? moment(promotion.from).format("MMM D, YYYY") : null}
        />
        <DetailField
          label="Valid until"
          value={promotion.to ? moment(promotion.to).format("MMM D, YYYY") : null}
        />
        {/* canUse / canNotUse are customer lists; the count is the useful
            part of them on a details panel. */}
        <DetailField label="Redeemed by" value={`${used} customer${used === 1 ? "" : "s"}`} />
        <DetailField
          label="Restricted to"
          value={eligible ? `${eligible} customer${eligible === 1 ? "" : "s"}` : "Everyone"}
        />
      </div>
    </div>
  );
};

export default PromotionDetails;
